module.exports = __webpack_public_path__ + "img/about_office_2.9aa11864.jpg";